/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ICD10Procedure from './icd-10-procedure';
import ICD10ProcedureDetail from './icd-10-procedure-detail';
import ICD10ProcedureUpdate from './icd-10-procedure-update';
import ICD10ProcedureDeleteDialog from './icd-10-procedure-delete-dialog';

const ICD10ProcedureRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ICD10Procedure />} />
    <Route path="new" element={<ICD10ProcedureUpdate />} />
    <Route path=":id">
      <Route index element={<ICD10ProcedureDetail />} />
      <Route path="edit" element={<ICD10ProcedureUpdate />} />
      <Route path="delete" element={<ICD10ProcedureDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ICD10ProcedureRoutes;
